import React, { useState } from 'react';
import { VQ } from '../../../../../store/student/types';
import {
  DateInputWithConfirm,
  InputWithConfirm,
  TextareaWithConfirm,
  getStringFromDate,
  getDateFromString,
  ContinueButton,
  isValidDate,
} from 'shared-components';
import { IDate, IExclusionOrder } from '../../../../../types';
import { useTranslation } from "react-i18next";

interface IProps {
  index: number;

  exclusionDate: string;
  reason: string;
  reference: string;

  onSaveAndClose: (trip: IExclusionOrder) => void;
}

const ExclusionOrders = (props: IProps) => {
    const { t } = useTranslation('common');
  const { index, onSaveAndClose } = props;
  const [dExclusion, setDExclusion] = useState(() => getDateFromString(props.exclusionDate));
  const [dExclusionError, setDExclusionError] = useState('');
  const [reason, setReason] = useState(props.reason);
  const [reference, setReference] = useState(props.reference);

  const saveAndClose = () => {
    onSaveAndClose({
      exclusionDate: getStringFromDate(dExclusion),
      reason,
      reference,
    });
  };

  const handleOnSaveAndCloseClick = (_event: React.MouseEvent<HTMLButtonElement>) => {
    saveAndClose();
  };

  const validateDate = (dateValue: IDate): string => {
    const { YYYY, DD, MM } = dateValue;

    if (YYYY && DD && MM) {
      const isValid = isValidDate(dateValue);
      if (!isValid) {
        return "Doesn't look like a valid date";
      }
      return '';
    }

    return '';
  };

  const complete =
    dExclusion.DD !== null &&
    dExclusion.MM !== null &&
    dExclusion.YYYY !== null &&
    dExclusionError === '' &&
    reason !== '' &&
    reference !== '';

  return (
    <>
      <DateInputWithConfirm
        key={`${VQ.EXCLUSION_DATE}-${index}`}
        id={`${VQ.EXCLUSION_DATE}-${index}`}
        label={t('common:dateOfExclusion')}
        value={dExclusion}
        errorText={dExclusionError}
        onChangeDD={(evt: any) => setDExclusion({ ...dExclusion, DD: evt.target.value })}
        onChangeMM={(evt: any) => setDExclusion({ ...dExclusion, MM: evt.target.value })}
        onChangeYY={(evt: any) => setDExclusion({ ...dExclusion, YYYY: evt.target.value })}
        onBlur={(_evt: any) => setDExclusionError(validateDate(dExclusion))}
      />

      <TextareaWithConfirm
        key={`${VQ.EXCLUSION_REASON}-${index}`}
        id={`${VQ.EXCLUSION_REASON}-${index}`}
        value={reason}
        label={t('common:reasonForExclusion')}
        onChange={(evt: any) => setReason(evt.currentTarget.value)}
      />

      <InputWithConfirm
        key={`${VQ.EXCLUSION_REFERENCE}-${index}`}
        id={`${VQ.EXCLUSION_REFERENCE}-${index}`}
        value={reference}
        label={t('common:referenceNumber')}
        onChange={(evt: any) => setReference(evt.currentTarget.value)}
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default ExclusionOrders;
